import React from "react";
import Header from "./common/Header";
import Banner from "./common/Banner";
import Footer from "./common/Footer";
import TabCar from "./common/TabCar";
import Services from "./common/Services";
import { importAll } from "./helper";

function Home() {
  const images = importAll(
    require.context("../assets/images", false, /\.(png|jpe?g|svg)$/)
  );

  const banner = [
    images["slider_01.jpeg"],
    images["banner-02.jpeg"],
    images["banner-03.png"],
    images["banner.jpeg"],
  ];

  return (
    <section className="container-full">
      <Header />
      <Banner data={banner} />
      <TabCar />
      <Services />
      <Footer />
    </section>
  );
}

export default Home;
